﻿﻿import { IContact } from './contact';

export interface IProductCenter {
    id: number;
    centerId: number;
    centerAlias: string;
    productId: number;
    productName: string;
    productAlias: string;
    nextSteps: string;
    targetDate: string;
    closeDate: string;
    closedBy: IContact;
}
